import { combineReducers } from 'redux'
import facebook from './facebook'
import cognito from './cognito'
import users from './users'
import teams from './teams'
import invites from './invites'
import stages from './stages'
import payment from './payment'

const reducers = combineReducers({
  facebook,
  cognito,
  users,
  teams,
  invites,
  stages,
  payment
})

export default reducers